import React from 'react';
import {
  ReviewByUserWrapperDiv,
  AllReviewBtnDiv,
  AllReviewWrapDiv,
  TripAdvisorImage,
  SeeAllLink,
} from './TripAdvisor.styles';
import {ColumnW50Div} from './../../common/Layouts/Layouts';

import TaReview from './../TaReview/TaReview';
import TripAdvisorGuestSays from '../TripAdvisorGuestSays/TripAdvisorGuestSays';

import UserTaReview from './../UserTaReview/UserTaReview';
import {shallowEqual, useSelector} from 'react-redux';

//Selectors
import {snapDataSelector} from '@stencil/hotels-ugc-redux/src/hotels-ugc-selectors';

const TripAdvisor = () => {
  const snapData = useSelector(snapDataSelector, shallowEqual) || {};
  const {taData = {}} = snapData;
  const {reviews = [], readAllTAReviewsLink = '', ratings = []} = taData;

  return (
    <ReviewByUserWrapperDiv>
      <ColumnW50Div>
        <TaReview taData={taData} />
      </ColumnW50Div>
      <ColumnW50Div>
        <TripAdvisorGuestSays ratings={ratings} />
      </ColumnW50Div>

      {reviews.map(data => (
        <UserTaReview review={data} />
      ))}
      {readAllTAReviewsLink ? (
        <AllReviewWrapDiv>
          <AllReviewBtnDiv href={readAllTAReviewsLink} target="_blank" rel="noopener">
            <SeeAllLink>See all reviews on </SeeAllLink>
            <TripAdvisorImage
              src={'https://gos3.ibcdn.com/tripadvisornew-1579161174.png'}
              alt="Segment Image"
            />
          </AllReviewBtnDiv>
        </AllReviewWrapDiv>
      ) : (
        ''
      )}
    </ReviewByUserWrapperDiv>
  );
};

export default TripAdvisor;
